var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "column content page",
    attrs: {
      "id": "home-page"
    }
  }, [_c('div', {
    attrs: {
      "id": "home"
    }
  }, [_c('div', {
    staticClass: "top3 three"
  }), _vm._v(" "), _c('h1', {
    staticClass: "top"
  }, [_vm._v("Ready Made Go 3")]), _vm._v(" "), _c('div', {
    staticClass: "mid3 three"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "bot3 three"
  }), _vm._v(" "), _c('div', {
    staticClass: "right3 three"
  }), _vm._v(" "), _c('router-link', {
    staticClass: "button audiotour",
    attrs: {
      "to": "/audio-tour"
    }
  }, [_vm._v("Start Audio Tour")])], 1)])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "mid"
  }, [_vm._v("20–24 September"), _c('br'), _vm._v("2017")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "bot"
  }, [_vm._v("Ace Hotel"), _c('br'), _vm._v("London")])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-77636ccf","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/HomePage.vue
// module id = +FwO
// module chunks = 1